import DesignTokens from '@tableau/design-tokens';
import { NotificationAlertLowShieldOutlineBaseIcon } from '@tableau/icons/NotificationAlertLowShieldOutlineBaseIcon';
import { PopoverInstance, PopoverWidget, TextLinkWidget } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';
import { applyColor }from '~src/style/ColorService';

import { Alert } from '../types/Alert';
import { AlertDetailsBody } from './AlertDetailsBody';

export type AlertDetailsPopoverProps = Readonly<{
  alerts: ReadonlyArray<Alert>;
}>;

export function AlertDetailsPopover(props: AlertDetailsPopoverProps) {
  const popoverInstance = React.useRef<PopoverInstance>(null);
  if (props.alerts === undefined || props.alerts.length === 0) {
    return <></>;
  }

  return (
    <PopoverWidget
      testId='cluster-alert-popover'
      aria-describedby='alertDescription'
      placement='bottom'
      popoverContent={renderPopoverContent(props.alerts)}
      ref={popoverInstance}
      title={popoverTitle(props.alerts)}
      showTitleBar={true}
      width={400}
      triggerElement={<span className={'tb-data-grid-cell-text-data-connect tb-lr-padded-wide'}><NotificationAlertLowShieldOutlineBaseIcon
        size={16}
        alt={''}
        className={alertIconClass}
        color={applyColor(DesignTokens.color.component.content.header.default.info, '#05628A')}
      />
      <TextLinkWidget testId={'data-connect-alert-popover-test-link'}  className={blueText}
          target={'_blank'}> {props.alerts.length === 0? 1 : props.alerts.length }
          &nbsp;
          {props.alerts.length > 1 ?   Messages.dataConnectSiteSettingsAlertMore()  : Messages.dataConnectSiteSettingsAlertOne()}
      </TextLinkWidget> </span>}
    />
  );
}

const popoverTitle =(alerts: ReadonlyArray<Alert>) => (<>
    <NotificationAlertLowShieldOutlineBaseIcon
      size={14}
      alt={''}
      className={alertIconClass}
    />
    <span >{alerts.length === 0? 1 : alerts.length} {alerts.length > 1 ?
    Messages.dataConnectSiteSettingsAlertMoreTitle(): Messages.dataConnectSiteSettingsAlertOneTitle()}</span>

</>);

const renderPopoverContent = (alerts: ReadonlyArray<Alert>) =>(<>
<form>
<table id='alertDescription' style={{marginTop: '2px'}}>
  <AlertDetailsBody alerts ={alerts} />
</table>
</form>
</>);


export const alertIconClass = cssClass('alert', 'icon', {
  verticalAlign: 'middle',
  paddingRight: 2,
  paddingBottom: 4,
});

const blueText = style({
  color: applyColor(DesignTokens.color.component.content.header.default.info, '#05628A')
});